import { render, staticRenderFns } from "./ViewNotesModal.vue?vue&type=template&id=5b719c50&scoped=true&"
import script from "./ViewNotesModal.vue?vue&type=script&lang=js&"
export * from "./ViewNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewNotesModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewNotesModal.vue?vue&type=style&index=1&id=5b719c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b719c50",
  null
  
)

export default component.exports